module.exports = __webpack_public_path__ + "img/btn_close.8dc8bf57.svg";